const parametro = {
  readParametroDocumentoTipos: 'parametros/documento_tipos/{{id_pais}}',
  readParametroPaises: 'parametros/paises',
  readParametroProvincias: 'parametros/provincias/{{id_pais}}'
}

export default parametro
